import {Store} from '../models/store.model';
import {StoreRepository} from '../repository/StoreRepository';

export class UpdateStoreUseCase {
  constructor (private storeRepository: StoreRepository) {}

  async execute (id: string, store: Store): Promise<Store> {
    return this.storeRepository.update(id, store);
  }
}
